<template>
	<GmapCustomMarker
		:marker="markerOptions.latlng"
		:z-index="zIndex"
		@mouseenter.native="zIndex = 60"
		@mouseleave.native="zIndex = 50"
	>
		<div
			class="container__marker__ocorrencia__com__foto"
			@click="zoomFoto(markerOptions)"
		>
			<img :src="markerOptions.urlImagem" />
		</div>
	</GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
	name: 'ParcelaMarker',
	components: {
		GmapCustomMarker,
	},
	props: {
		markerOptions: Object,
	},
	data: () => {
		return {
			zIndex: 50,
		}
	},
	methods: {
		zoomFoto(ocorrencia) {
			this.$emit('ampliarFoto', ocorrencia)
		},
	},
}
</script>

<style>
.container__marker__ocorrencia__com__foto {
	border: 2px solid white;
}

.container__marker__ocorrencia__com__foto > img {
	height: 75px;
	width: 75px;
}

.container__marker__ocorrencia__com__foto > img:hover {
	height: 150px;
	width: 150px;
	cursor: zoom-in;
}
</style>
